import { UPDATESTEP1_OK, UPDATESTEP1_ERR } from "./updateStep1.action";

const InitState = {
  error: null,
  content: null,
};

export default function UpdateStep1Reducer(state = InitState, action) {
  switch (action.type) {
    case UPDATESTEP1_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case UPDATESTEP1_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
